// Um evento é considerado "encerrado" quando a data limite (ou, na ausência dela,
// a data do próprio evento) já passou. Não usamos a ausência de lote/preço aqui —
// isso faria eventos futuros sem lote configurado ainda sumirem da home.
export const isEventoClosed = (evento) => {
  const referencia = evento.data_validade_evento || evento.data_evento;
  return !!referencia && new Date(referencia) < new Date();
};
